import * as React from 'react';
import KeyboardOutlined from './keyboard-outlined';
import KeyboardFilled from './keyboard-filled';
import type { IconCombinedProps } from './types';
const KeyboardCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <KeyboardFilled ref={ref} {...rest} />;
  }
  return <KeyboardOutlined ref={ref} {...rest} />;
});
export default KeyboardCombined;